module.exports = __webpack_public_path__ + "static/media/odnoklassniki.1f01a5c7.svg";